import Alpine from 'alpinejs';

Alpine.data('accordion', (behavior) => ({
  openItems: [],
  
  toggle(index) {
    if (behavior === 'single') {
      this.openItems = this.openItems.includes(index) ? [] : [index];
    } else {
      if (this.openItems.includes(index)) {
        this.openItems = this.openItems.filter(i => i !== index);
      } else {
        this.openItems.push(index);
      }
    }
  },
  
  isOpen(index) {
    return this.openItems.includes(index);
  }
}));